import { useEffect } from 'react';

const HapticFeedbackProvider = ({ children }) => {
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    
    if (!tg || !tg.HapticFeedback) {
      return;
    }

    // Функция для добавления haptic feedback к элементу
    const addHapticFeedback = (event) => {
      const target = event.target;
      
      // Проверяем, является ли элемент или его родитель кликабельным
      const clickableElement = target.closest('button, a, [role="button"], .nav-item, .clickable, input[type="button"], input[type="submit"], .story-item, .story-preview, .tag-item, .settings-item, .admin-nav-item, .story-close, .nav-button, .expand-toggle-button, .preview-button, .view-button');
      
      if (clickableElement) {
        // Определяем стиль вибрации в зависимости от типа элемента
        let style = 'light';
        
        // Для важных действий используем более сильную вибрацию
        if (clickableElement.classList.contains('delete') || 
            clickableElement.classList.contains('danger') ||
            clickableElement.type === 'submit') {
          style = 'medium';
        }
        
        // Для навигационных элементов используем легкую вибрацию
        if (clickableElement.classList.contains('nav-item') ||
            clickableElement.classList.contains('story-item')) {
          style = 'light';
        }
        
        tg.HapticFeedback.impactOccurred(style);
      }
    };

    // Добавляем обработчик на документ для перехвата всех кликов
    document.addEventListener('click', addHapticFeedback, true);

    // Очистка при размонтировании
    return () => {
      document.removeEventListener('click', addHapticFeedback, true);
    };
  }, []);

  return children;
};

export default HapticFeedbackProvider;
